import { Form } from "react-bootstrap";

/**
 * Стандартний випадаючий список проєкту: стилі як у PR+ / «Виробництво»
 * (глобально для `select.form-select` у `styles/components/_app-form-controls.scss`).
 */
export function AppSelect(props) {
    return <Form.Select {...props} />;
}
